import { firstToLowerCase } from '../../common/utils/helper';
import { TechnicalAnalysis } from './indicator-base';
/**
 * `TmaIndicator` module is used to render TMA indicator.
 */
export class TmaIndicator extends TechnicalAnalysis {
    /**
     * Defines the predictions based on TMA approach
     *
     * @private
     */
    initDataSource(indicator, chart) {
        const tmaPoints = [];
        const field = firstToLowerCase(indicator.field);
        const xField = 'x';
        //prepare data
        const validData = indicator.points;
        if (validData && validData.length && validData.length >= indicator.period) {
            const signalSeries = indicator.targetSeries[0];
            //prepare data
            const validData = indicator.points;
            if (validData.length && validData.length >= indicator.period) {
                let sum = 0;
                const smaValues = [];
                //sma values
                let index = 0;
                let length = validData.length;
                const period = indicator.period;
                while (length >= period) {
                    sum = 0;
                    index = validData.length - length;
                    for (let j = index; j < index + period; j++) {
                        sum = sum + validData[j][field];
                    }
                    sum = sum / period;
                    smaValues.push(sum);
                    length--;
                }
                //initial values
                for (let k = 0; k < period - 1; k++) {
                    sum = 0;
                    for (let j = 0; j < k + 1; j++) {
                        sum = sum + validData[j][field];
                    }
                    sum = sum / (k + 1);
                    smaValues.splice(k, 0, sum);
                }
                index = indicator.period;
                while (index <= smaValues.length) {
                    sum = 0;
                    for (let j = index - indicator.period; j < index; j++) {
                        sum = sum + smaValues[j];
                    }
                    sum = sum / indicator.period;
                    tmaPoints.push(this.getDataPoint(validData[index - 1][xField], sum, validData[index - 1], signalSeries, tmaPoints.length));
                    index++;
                }
            }
        }
        this.setSeriesRange(tmaPoints, indicator);
    }
    /**
     * To destroy the TMA indicator.
     *
     * @returns {void}
     * @private
     */
    destroy() {
        /**
         * Destroys the TMA Indicator
         */
    }
    /**
     * Get module name.
     */
    getModuleName() {
        /**
         * Returns the module name of the series
         */
        return 'TmaIndicator';
    }
}
